import { defineRecipe } from "@chakra-ui/react-v3";

import { focusRingInline } from "theme/tokens/accessibility";

export const numberSelectorRecipe = defineRecipe({
  base: {
    w: "12",
    h: "8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid",
    borderColor: "neutral.subtle",
    borderRadius: "md",
    bg: "bg.container",
    color: "fg.default",
    cursor: "pointer",
    userSelect: "none",
    transition: "background 0.2s, color 0.2s",

    _hover: {
      background: "neutral.muted",
    },

    _focusVisible: {
      ...focusRingInline,
    },

    _selected: {
      bg: "highlight.subtle",
      borderColor: "highlight.solid",
    },

    _disabled: {
      opacity: 0.5,
    },
  },
});
